import { createReducer } from '@reduxjs/toolkit';
import { notificationApi } from 'services/company/notification';

const initialState = {
  system_notification: null,
}

const latestSystemNotificationReducer = createReducer(initialState, (builder) => {
  builder
    .addMatcher(notificationApi.endpoints.getLatestSystemNotification.matchFulfilled, (state, action) => {
      state.system_notification = action.payload.system_notification;
    })
})

export default latestSystemNotificationReducer;
